import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState(token ? "verifying" : "no-token"); // verifying | done | failed | no-token
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (!token || ran.current) return;
    ran.current = true; // StrictMode double-invoke guard — token is single-use
    api.post("/auth/verify-email", { token })
      .then(() => setState("done"))
      .catch((e) => {
        setError(formatApiError(e.response?.data?.detail) || "Verification failed");
        setState("failed");
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-[#F7F5F0] flex items-center justify-center p-8">
      <div className="w-full max-w-md text-left">
        <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#6C7565]">Email verification</span>

        {state === "verifying" && (
          <h2 className="font-serif text-4xl mt-2 tracking-tight" data-testid="verify-progress">Checking your link…</h2>
        )}

        {state === "done" && (
          <div data-testid="verify-success">
            <h2 className="font-serif text-4xl lg:text-5xl mt-2 tracking-tight">Verified.</h2>
            <div className="border-2 border-[#2E6F40] bg-white p-8 mt-8 shadow-[6px_6px_0px_#2E6F40]">
              <p className="font-serif text-xl leading-relaxed">Your email is confirmed. Your ledger awaits.</p>
            </div>
            <Link to="/app" className="inline-block mt-8 bg-[#1A1F16] text-[#F7F5F0] px-8 py-4 uppercase tracking-[0.25em] text-xs hover:bg-[#2C3628] transition-colors" data-testid="verify-continue-btn">
              Open my ledger →
            </Link>
          </div>
        )}

        {(state === "failed" || state === "no-token") && (
          <div data-testid="verify-failed">
            <h2 className="font-serif text-4xl lg:text-5xl mt-2 tracking-tight">Link expired.</h2>
            <div className="border-2 border-[#D94F3D] bg-white p-8 mt-8">
              <p className="font-serif text-xl leading-relaxed">
                {state === "no-token" ? "This verification link is incomplete." : error}
              </p>
              <p className="font-mono text-[10px] uppercase tracking-widest text-[#6C7565] mt-4">
                Sign in and use "Resend verification" from the banner.
              </p>
            </div>
            <Link to="/login" className="inline-block mt-8 border border-[#1A1F16] px-8 py-4 uppercase tracking-[0.25em] text-xs hover:bg-[#1A1F16] hover:text-[#F7F5F0] transition-colors" data-testid="verify-to-login-btn">
              Go to sign in →
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
